import { render, staticRenderFns } from "./PersonGroups.vue?vue&type=template&id=3f9c042a&scoped=true&"
import script from "./PersonGroups.vue?vue&type=script&lang=js&"
export * from "./PersonGroups.vue?vue&type=script&lang=js&"
import style0 from "./PersonGroups.vue?vue&type=style&index=0&id=3f9c042a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9c042a",
  null
  
)

export default component.exports